import React from 'react';
import IntroductionAudio from '../IntroductionAudio';

const VideoBlock = ({ block }) => {
  if (!block || !block.videoUrl) return null;

  
  const isYouTubeUrl = (url) => {
    if (!url) return false;
    return /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/.test(url);
  };

  const getYouTubeEmbedUrl = (url) => {
    if (!url) return null;
    
    let videoId = null;
    
    if (url.includes('youtube.com/embed/')) {
      const match = url.match(/embed\/([^?&]+)/);
      videoId = match ? match[1] : null;
    } else {
      const patterns = [
        /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/,
        /youtube\.com\/watch\?v=([^"&?\/\s]{11})/,
        /youtu\.be\/([^"&?\/\s]{11})/
      ];
      
      for (const pattern of patterns) {
        const match = url.match(pattern);
        if (match && match[1]) {
          videoId = match[1];
          break;
        }
      }
    }
    
    if (!videoId) return null;
    
    const embedUrl = `https://www.youtube-nocookie.com/embed/${videoId}`;
    const params = `rel=0&modestbranding=1&playlist=${videoId}&loop=0&iv_load_policy=3&enablejsapi=1`;
    
    return `${embedUrl}?${params}`;
  };

  const isYouTube = isYouTubeUrl(block.videoUrl);
  const embedUrl = isYouTube ? getYouTubeEmbedUrl(block.videoUrl) : null;

  return (
    <div className="video-block mb-6 p-6 bg-gray-50 rounded-lg">
      {block.title && (
        <h4 className="text-lg font-semibold mb-2 text-gray-800">{block.title}</h4>
      )}
      {block.description && (
        <p className="text-gray-600 mb-4">{block.description}</p>
      )}
      {block.introductionAudio && (
        <div className="mb-4">
          {block.introductionAudio.description && (
            <p className="text-gray-700 mb-2">{block.introductionAudio.description}</p>
          )}
          <IntroductionAudio
            audio={block.introductionAudio}
            autoPlay={block.introductionAudio.autoPlay}
          />
        </div>
      )}
      <div className="flex justify-center">
        {isYouTube && embedUrl ? (
          <iframe
            src={embedUrl}
            className="rounded-lg shadow-md"
            style={{
              maxWidth: '1000px',
              width: '100%',
              maxHeight: '450px',
              height: '450px',
              aspectRatio: '16/9',
              border: 'none'
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={block.title || 'YouTube video player'}
          />
        ) : (
          <video 
            controls 
            className="rounded-lg shadow-md"
            style={{ 
              maxWidth: '1000px', 
              width: '100%', 
              maxHeight: '450px',
              height: 'auto',
              aspectRatio: '16/9'
            }}
            src={block.videoUrl}
            poster={block.thumbnailUrl}
          >
            Your browser does not support the video element.
            {block.captions && (
              <track
                kind="captions"
                src={block.captions}
                srcLang="en"
                label="English"
              />
            )}
          </video>
        )}
      </div>
      {block.caption && (
        <p className="text-sm text-gray-600 mt-2 italic">{block.caption}</p>
      )}
    </div>
  );
};

export default VideoBlock;

